import {SavingState} from 'constants/RegistryConstants';
import makeUseGlobalClientState, {
  UseGlobalClientStateOutput,
} from 'ui-library/hooks/global-client-state/makeUseGlobalClientState';

const DEFAULT_TAG_SCHEMA_SAVING_CLIENT_STATE = SavingState.COMPLETED;

const tagSchemaSavingClientState = makeUseGlobalClientState<SavingState>(
  DEFAULT_TAG_SCHEMA_SAVING_CLIENT_STATE
);

export const GLOBAL_TAG_SCHEMA_CLIENT_SAVING_STATE_ID = 'tagSchemaClientSavingState';

export function setTagSchemaSavingState(savingState: SavingState): void {
  tagSchemaSavingClientState.updateState(GLOBAL_TAG_SCHEMA_CLIENT_SAVING_STATE_ID, savingState);
}

export function getTagSchemaSavingState(): SavingState {
  return tagSchemaSavingClientState.getState(GLOBAL_TAG_SCHEMA_CLIENT_SAVING_STATE_ID);
}

export function useTagSchemaSavingState(): UseGlobalClientStateOutput<SavingState> {
  return tagSchemaSavingClientState.useGlobalClientState(GLOBAL_TAG_SCHEMA_CLIENT_SAVING_STATE_ID);
}
